import React, { Component } from 'react';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../../content/css/ContractReviewer.css';
import { contractReviewerActions as actions } from '../../../actions';
import { contractReviewerConstants } from '../../../constants';
import { LoadingIcon } from '../../LoadingIcon';
import LoadingListener from '../../../helpers/loadingListener';
import AuthService from '../../../services/auth.service';
import DocumentList from './DocumentList';
import ListPagination from '../../Misc/ListPagination';

const ownerFilterType = {
    SHOW_ALL: "SHOW_ALL",
    SHOW_MINE: "SHOW_MINE"
}

class DocumentsView extends Component {

    constructor(props, context) {
        super(props, context);

        this.authService = new AuthService();
        this.state = {
            filteredDocuments: this.filterDocuments(this.props.documents, this.getUserId(), [2024], ownerFilterType.SHOW_MINE),
            timeFilter: [2024],
            ownerFilter: ownerFilterType.SHOW_MINE
        };

        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENTS_LIST_REQUEST]);
    }

    componentDidMount() {
        this.props.requestDocumentsList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.documents != this.props.documents) {
            let userId = this.getUserId();
            this.setState({ filteredDocuments: this.filterDocuments(this.props.documents, userId, this.state.timeFilter, this.state.ownerFilter) });
            let year = this.getLatestUploadDateAsYear(this.props.documents);
            this.setState({ timeFilter: year ? [year] : [2024] });
        }
        if (prevState.timeFilter != this.state.timeFilter) {
            let userId = this.getUserId();
            this.setState({ filteredDocuments: this.filterDocuments(this.props.documents, userId, this.state.timeFilter, this.state.ownerFilter) });
        }
        if (prevState.ownerFilter != this.state.ownerFilter) {
            let userId = this.getUserId();
            this.setState({ filteredDocuments: this.filterDocuments(this.props.documents, userId, this.state.timeFilter, this.state.ownerFilter) });
        }
    }

    getUserId = () => {
        if (this.authService.isFreemium()) return null;
        return this.authService.isAdmin() || this.authService.isCustomer() ? this.authService.getUserId() : this.authService.getExistingGuestId();
    }

    getLatestUploadDateAsYear = (documents) => {
        let years = this.getYears(documents);
        return Math.max(...years);
    }

    handleYearFilterClick = (year) => {
        let timeFilter = this.state.timeFilter;
        /*let hasYear = filter.includes(year);
        if (hasYear) filter = filter.filter(x => x == year);
        else filter.push(year);*/
        timeFilter = [year];

        this.setState({ timeFilter });
    }

    handleOwnerFilterChange = (eventKey, event) => {
        this.setState({ ownerFilter: eventKey });
    }

    filterDocuments = (documents, userId, timeFilter, ownerFilter) => {
        return documents.filter(x => this.isFromYear(x, timeFilter) && this.isOwner(x, userId, ownerFilter));
    }

    isOwner = (doc, userId, filter) => {
        if (this.authService.isFreemium()) return true;
        if (filter == ownerFilterType.SHOW_MINE) return doc.uploaderId == userId;
        else if (filter == ownerFilterType.SHOW_ALL) return true;
    }

    isFromYear(doc, years) {
        let year = new Date(doc.wasSaved).getFullYear();
        return years.includes(year);
    }

    getYears = (documents) => {
        return [...new Set(documents.map(x => new Date(x.wasSaved).getFullYear()))];
    }

    renderYearButtons() {
        let years = this.getYears(this.props.documents);
        if (years.length <= 1) return;

        return this.getYears(this.props.documents).map(year => (
            <Button active={this.state.timeFilter.includes(year)} onClick={() => this.handleYearFilterClick(year)}>{year}</Button>
        ));
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let isAdmin = this.authService.isAdmin();

        return (
            <div className="overview">
                {isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {!isLoading &&
                    <React.Fragment>
                        <h3>Your uploaded documents</h3>
                        <hr />
                        <div className="filter-btn-group">
                            {this.renderYearButtons()}
                            {isAdmin &&
                                <div className="filter-owner">
                                    <DropdownButton title={`Filter: ${this.state.ownerFilter}`} id={`dropdown-basic`} onSelect={this.handleOwnerFilterChange} pullRight>
                                        <MenuItem key={ownerFilterType.SHOW_MINE} eventKey={ownerFilterType.SHOW_MINE}>{ownerFilterType.SHOW_MINE}</MenuItem>
                                        <MenuItem key={ownerFilterType.SHOW_ALL} eventKey={ownerFilterType.SHOW_ALL}>{ownerFilterType.SHOW_ALL}</MenuItem>
                                    </DropdownButton>
                                </div>
                            }
                        </div>

                        <ListPagination
                            items={this.state.filteredDocuments}
                            itemsPerPage={10}
                        >
                            <DocumentList
                                onDelete={this.props.deleteDocument}
                            />
                        </ListPagination>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(DocumentsView);



// WEBPACK FOOTER //
// ./src/components/Home/DocumentList/DocumentsView.js